import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const productTransactionApi = createApi({
  reducerPath: "productTransactionApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["ProductTransaction", "ProductTransactionDetailsResponse"],
  endpoints: (build) => ({
    filterProductTransactions: build.query<
      ProductTransaction[],
      { companyId: number; serviceId: number; filter: ProductTransactionFilter }
    >({
      query: ({ companyId, serviceId, filter }) => ({
        url: `${companyId}/services/${serviceId}/product-txs`,
        method: "POST",
        body: filter,
      }),
      providesTags: ["ProductTransaction"],
    }),
    fetchExternalTransactionDetails: build.query<
      ProductTransactionExternalDetailsResponse,
      { companyId: number; serviceId: number; nettpayRef: string }
    >({
      query: ({ companyId, serviceId, nettpayRef }) => ({
        url: `${companyId}/services/${serviceId}/product-txs/external/${nettpayRef}`,
        method: "GET",
      }),
      providesTags: ["ProductTransactionDetailsResponse"],
    }),
  }),
});
